<div>
    <h2 mat-dialog-title>Edit Iteration - {{iteration?.year}}</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Year</mat-label>
                            <input required matInput name="year" id="year" type="number" formControlName="year"
                                [min]="2000" [max]="2100" />
                            <mat-error *ngIf="form.get('year').errors?.required">Year is required</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Entry Fee</mat-label>
                            <input required matInput name="entryFee" id="entryFee" type="number" placeholder="0.00"
                                formControlName="entryFee" [min]="0" step="0.01" />
                            <span matPrefix>$&nbsp;</span>
                            <mat-error *ngIf="form.get('entryFee').errors?.required">Entry Fee is required
                            </mat-error>
                            <mat-error *ngIf="form.get('entryFee').errors?.min">Entry Fee must be 0 or greater
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Date</mat-label>
                            <input required matInput [matDatepicker]="startPicker" formControlName="startDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                            <mat-error *ngIf="form.get('startDateOnly').errors?.required">Start Date is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Date</mat-label>
                            <input required matInput [matDatepicker]="endPicker" formControlName="endDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                            <mat-error *ngIf="form.get('endDateOnly').errors?.required">End Date is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Time</mat-label>
                            <input required matInput [matTimepicker]="startTimePicker" formControlName="startTimeOnly" />
                            <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"/>
                            <mat-timepicker #startTimePicker/>
                            <mat-error *ngIf="form.get('startTimeOnly').errors?.required">Start Time is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Time</mat-label>
                            <input required matInput [matTimepicker]="endTimePicker" formControlName="endTimeOnly" />
                            <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"/>
                            <mat-timepicker #endTimePicker/>
                            <mat-error *ngIf="form.get('endTimeOnly').errors?.required">End Time is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Notes</mat-label>
                            <textarea matInput name="notes" id="notes" placeholder="Notes (optional)" rows="3"
                                formControlName="notes"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="bookings().length > 0">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                <div class="col-12">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Bookings 
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <span class="text-muted small">If start and end times are being modified, select the bookings that are affected by the changes.</span>
                        <span class="text-muted small"></span>
                        <table mat-table [dataSource]="bookings()">
                            <ng-container matColumnDef="selected">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox 
                                    [checked]="allSelected()"
                                    [indeterminate]="partiallySelected()"
                                    (change)="toggleAllSelections($event.checked)"
                                    [disabled]="isSelectedAllDisabled()"
                                    [matTooltipDisabled]="!isSelectedAllDisabled()"
                                    matTooltip="All bookings are in the past, unable to modify"
                                    disabledInteractive></mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let booking">
                                    <mat-checkbox [checked]="booking.selected"
                                    (change)="toggleSelection(booking)"
                                    [disabled]="isBookingPast(booking)"
                                    [matTooltipDisabled]="!isBookingPast(booking)"
                                    matTooltip="Booking is in the past, unable to modify"
                                    disabledInteractive
                                    >
                                </mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="simulator">
                                <th mat-header-cell *matHeaderCellDef> Simulator </th>
                                <td mat-cell *matCellDef="let booking">  {{booking.bayNumber}} ({{booking.bayName}}) </td>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef> Date </th>
                                <td mat-cell *matCellDef="let booking"> {{formatInUserTimezone(booking.startTime, 'MM/DD/YYYY')}} </td>
                            </ng-container>
                            <ng-container matColumnDef="timeSlot">
                                <th mat-header-cell *matHeaderCellDef> Time Slot </th>
                                <td mat-cell *matCellDef="let booking"> {{formatInUserTimezone(booking.startTime, 'h:mm A')}} - {{formatInUserTimezone(booking.endTime, 'h:mm A')}} </td>
                            </ng-container>
                            <ng-container matColumnDef="confirmationNumber">
                                <th mat-header-cell *matHeaderCellDef> Confirmation Number </th>
                                <td mat-cell *matCellDef="let booking"> {{booking.confirmationNumber}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </mat-expansion-panel>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button class="warning" type="button" (click)="dialogRef.close('cancel')" color="warn"
                    [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>